/**
 * The default file size threshold in bytes for uploads.
 *
 * This constant is set to 10 megabytes (10 * 1024 * 1024 bytes).
 * It is typically used to determine when to apply special handling
 * or validation for files exceeding this size during upload processes.
 */
export const DEFAULT_THRESHOLD_BYTES = 10 * 1024 * 1024; // 10 MB
